export default function translate(i18n, propriete) {
  if (propriete === 'userNameOrEmailAddress') return i18n.t('connexion.required.identifiant');
  if (propriete === 'password') return i18n.t('connexion.required.mdp');

  return propriete;
}
